import React from 'react'
import PropTypes from 'prop-types'
import Spinner from '../common/Spinner';

const TableNestedManagement = ({ tableData, refresh }) => {
  const valueConvert = (val, prec=2) => {
    if(typeof val === typeof 1) return Number(val).toFixed(prec).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",")
    return val
  }

  if(tableData){
    return (
      <>
        {/* <table className='table table-border' style={{marginBottom:'0'}}>
          <thead className='tryColor'>
            <tr>
              <th >Numer OPK</th>
              <th>Nazwa OPK</th>
              {Object.keys(tableData[0]).length==5 ?<>
                <th style={{width:"23%"}} >Liczba wykonanych procedur/&#8203;usług</th>
                <th style={{width:"25%"}}>Koszt wykonanych procedur/&#8203;usług [zł]</th>
              </>:<>
                <th style={{width:"25%"}}>Koszt [zł]</th>
              </>}
              <th style={{width:"22%"}}>Udział % w kosztach całkowitych</th>
            </tr>
          </thead>
          <tbody className=''> */}
            {tableData.map((item, i) => {
              return (<tr key={`rep2-${i}`} className={item.code=="Wartość ogółem"?'tdTitles tryColor':'tryColor'}>
                <td className='' key={`rep2-${i}-code`}>{item.code}</td>
                <td className='' key={`rep2-${i}-name`}>{item.name}</td>
                <td className='rightAlignCell' key={`rep2-${i}-koszt_proc_us`}>{valueConvert(item.koszt)}</td>
                <td className='rightAlignCell' key={`rep2-${i}-przek_koszt`}>{valueConvert(item.koszt_proc)}%</td>
              </tr>)
            })}
          {/* </tbody>
        </table> */}
      </>
    )
  }else{
    return <Spinner />
  }
}
TableNestedManagement.propTypes = {
  tableData: PropTypes.object,
  refresh: PropTypes.bool.isRequired,
}
export default TableNestedManagement
